import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-add-button-sm',
    templateUrl: './add-button-sm.component.html',
    styleUrls: ['./add-button-sm.component.scss'],
})
export class AddButtonSmComponent {
    @Input() isLoading: boolean = true;
    @Input() isActive: boolean = true;
}